export default __webpack_public_path__ + "static/media/14 IDENTIDAD PERDIDA.823403c4.png";